export const PROJECT_CLOUD_PROVIDERS = {
  gcp: ["us-central1", "us-east1", "us-west1"],
} as const;

export type CloudProvider = keyof typeof PROJECT_CLOUD_PROVIDERS;

export const DEFAULT_PROJECT_CLOUD_PROVIDER: CloudProvider = "gcp";
export const DEFAULT_PROJECT_REGION: (typeof PROJECT_CLOUD_PROVIDERS)[typeof DEFAULT_PROJECT_CLOUD_PROVIDER][number] =
  "us-central1";
